const KEY = "ac_last_page";

/** Payment gateways reload the app, so history can't take the user back; this can. */
export function rememberLastPage(path: string): void {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    /* storage blocked: result pages fall back to home */
  }
}

export function readLastPage(): string {
  try {
    return sessionStorage.getItem(KEY) || "/";
  } catch {
    return "/";
  }
}
